import { combineReducers } from "redux";

import workflowsReducer from "./workflowsReducer";
import authReducer from "./authReducer";
import calendarsReducer from "./calendarsReducer";
import companyReducer from "./companyReducer";
import customFieldsReducer from "./customFieldsReducer";
import dashboardReducer from "./dashboardReducer";
import employeesReducer from "./employeesReducer";
import expensesReducer from "./expensesReducer";
import functionsReducer from "./functionsReducer";
import groupsReducer from "./groupsReducer";
import modalReducer from "./modalReducer";
import plansReducer from "./plansReducer";
import rulesReducer from "./rulesReducer";
import shiftsReducer from "./shiftsReducer";
import { storeFoldersReducer } from "./storeFoldersReducer";
import timesReducer from "./timesReducer";
import ubicationsReducer from "./ubicationsReducer";
import undoHistoryReducer from "./undoHistoryReducer";

import { reducer as toastrReducer } from "react-redux-toastr";

const rootReducer = combineReducers({
	authReducer,
	companyReducer,
	dashboardReducer,
	employeesReducer,
	workflowsReducer,
	calendarsReducer,
	customFieldsReducer,
	expensesReducer,
	functionsReducer,
	groupsReducer,
	modalReducer,
	plansReducer,
	rulesReducer,
	shiftsReducer,
	storeFoldersReducer,
	timesReducer,
	toastr: toastrReducer,
	ubicationsReducer,
	undoHistoryReducer,
});

export default rootReducer;
